<template>
  <div class="_order-card-list">
    <template v-for="order in orders">
      <desktop-order-card
        :key="`desktop/${order._id}`"
        v-bind="order"
        :order-id="order._id"
        :is-new-line-official-account="isNewLineOfficialAccount(order.type)"
        :is-transfer-line-official-account="isTransferLineOfficialAccount(order.type)"
        :new-line-official-account-type-text="newLineOfficialAccountTypeText(order.type)"
        :transfer-agency-payment-type-text="transferAgencyPaymentTypeText(
          order.transferAgencyPaymentType
        )"
        class="d-none d-md-block mt-4"
        @delete="deleteOrder">
      </desktop-order-card>

      <mobile-order-card
        :key="`mobile/${order._id}`"
        v-bind="order"
        :order-id="order._id"
        :is-new-line-official-account="isNewLineOfficialAccount(order.type)"
        :is-transfer-line-official-account="isTransferLineOfficialAccount(order.type)"
        :new-line-official-account-type-text="newLineOfficialAccountTypeText(order.type)"
        :transfer-agency-payment-type-text="transferAgencyPaymentTypeText(
          order.transferAgencyPaymentType
        )"
        class="d-md-none mt-4"
        @delete="deleteOrder">
      </mobile-order-card>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OrderCardListIndex',
  components: {
    DesktopOrderCard: () => import('./DesktopOrderCard'),
    MobileOrderCard: () => import('./MobileOrderCard')
  },
  props: {
    orders: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    ...mapActions({
      deleteOrderById: 'Order/deleteOrderById'
    }),
    async deleteOrder(orderId, code) {
      const { value: confirm } = await this.$swal({
        title: 'ลบใบเสนอราคา',
        html: `คุณต้องการลบใบเสนอราคา <b>${code}</b><br>ใช่หรือไม่`,
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก'
      })
      this.$router.go()
      if (confirm) {
        await this.deleteOrderById(orderId)
      }
    },
    isNewLineOfficialAccount (orderType) {
      return orderType === 'newLineOfficialAccount'
    },
    isTransferLineOfficialAccount (orderType) {
      return orderType === 'transferLineOfficialAccount'
    },
    newLineOfficialAccountTypeText (orderType) {
      if (this.isTransferLineOfficialAccount(orderType)) {
        return 'ย้ายมาจาก Agency อื่น'
      }

      if (this.isNewLineOfficialAccount(orderType)) {
        return 'เปิด LINE Official Account ใหม่'
      }

      return ''
    },
    transferAgencyPaymentTypeText (transferAgencyPaymentType) {
      return transferAgencyPaymentType === 'lineThailand'
        ? 'ชำระผ่าน LINE Thailand'
        : 'ชำระผ่าน Agency เจ้าอื่น'
    }
  }
}
</script>
